module.exports = __webpack_public_path__ + "static/img/b.dbf85f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/b.png
// module id = 0NtL
// module chunks = 0